module.exports = __webpack_public_path__ + "img/liane2.fb5674e6.png";